import { render, staticRenderFns } from "./LibraryOrders.vue?vue&type=template&id=040ccfa8&scoped=true"
import script from "./LibraryOrders.vue?vue&type=script&lang=js"
export * from "./LibraryOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ccfa8",
  null
  
)

export default component.exports